import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'main',
    // component: ()=>import('@/views/admd')
    // component: ()=>import('@/views/abRouter')
     component: ()=>import('@/views/inst')
  },
  {
    /* форма партнерского колл-центра*/
    path: '/cc',
    name: 'cc',
    component: ()=>import('@/views/cc')
  },
  {
    /* одна из первых итераций лендинга*/
    path: '/lnd',
    name: 'lnd',
    component: ()=>import('@/views/lnd')
  },
  {
    /* хреновая версия лендинга*/
    path: '/abt',
    name: 'abt',
    component: ()=>import('@/views/abt')
  },
  {
    /* универсальный инстол и пдл*/
    path: '/pdl',
    name:'pdl',
    component: ()=>import('@/views/pdlloan/pdlLoan')
  },
  {
    path:'/pdlloan/:session_id/:token',
    name:'pdlLoan',
    component: ()=>import('@/views/pdlloan/docLoan')
  },
  {
    path:'/iu/:session_id/:token',
    name:'iu',
    component: ()=>import('@/views/pdlloan/docIU')
  },
  {
    path:'/boxStatement/:session_id/:token',
    name:'boxStatement',
    component: ()=>import('@/views/pdlloan/boxStatement')
  },
  {
    path:'/chdp/:session_id/:token',
    name:'chdp',
    component: ()=>import('@/views/pdlloan/docCHDP')
  },
  {
    path:'/ki/:session_id/:token',
    name:'ki',
    component: ()=>import('@/views/pdlloan/docKI')
  },
  {
    path:'/pdnil',
    name:'docPDN_IL',
    component: ()=>import('@/views/pdlloan/docPDN_IL')
  },
  {
    path:'/pdn/:session_id/:token',
    name:'docPDN_PDL',
    component: ()=>import('@/views/pdlloan/docPDN_PDL')
  },
  {
    path:'/reg',
    name:'registration',
    component: ()=>import('@/views/registration/instIndex.vue')
  },
  {
    path: '/video_call/:demand',
    name: 'video_call',
    component: () => import('@/components/video_call/VCallVideo.vue'),
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.publicPath,
  routes
});

export default router
